export const SPACE_DIRECTORY_KEY =
	'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
export const PEOPLE_DIRECTORY_KEY =
	'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
export const ANALYTICS_MODULE_KEY =
	'com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
export const ANALYTICS_COMPLETE_KEY = `com.atlassian.plugins.atlassian-connect-plugin:${ANALYTICS_MODULE_KEY}`;
export const FIND_NEW_APPS_KEY = 'com.atlassian.confluence.emcee__enduser-discover';
export const AUTOMATION_KEY =
	'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
